import { render, staticRenderFns } from "./DxTableProdcutos.vue?vue&type=template&id=6529a218&scoped=true&"
import script from "./DxTableProdcutos.vue?vue&type=script&lang=ts&"
export * from "./DxTableProdcutos.vue?vue&type=script&lang=ts&"
import style0 from "./DxTableProdcutos.vue?vue&type=style&index=0&id=6529a218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6529a218",
  null
  
)

export default component.exports